// for common data
export const COMMON_VALUES = 'COMMON_VALUES'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const LOGIN_MODAL = 'LOGIN_MODAL'
export const SIGNUP_MODAL = 'SIGNUP_MODAL'
export const UPDATE_CART_CHECKOUT = 'UPDATE_CART_CHECKOUT'
